import script from "./VideoStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./VideoStylePanel.vue?vue&type=style&index=0&id=ff7125dc&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff7125dc"]])

export default __exports__